import ForgetPasswordEntrepriseComponent from "../../../components/entreprise/forget-password/ForgetPasswordEntrepriseComponent";



export default function ForgetPasswordEntrepriseBloc() {

      return (  
        <div className="col-width-8">
            <h1 className="title">Mot de passe oublié ou initier un nouveau mot de passe: </h1>
            <div className="bg-blanc shadow-bleu p-lg m-y-lg">
                <ForgetPasswordEntrepriseComponent/>
            </div>
        </div>
    )
}